import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import {
  BigPicklistInput, BodyTextMedium, HeadlineTextMedium, TitleTextLarge,
} from 'Packages/FacetDesign/Components';
import useBoneBackgroundColor from 'Hooks/useBoneBackgroundColor';
import { AutoCompleteInputLarge } from 'Packages/FacetDesign/Components/AutoCompleteInput';
import Layout from './Layout';

const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => HeadlineTextMedium,
    _customProps: {
      color: 'textSecondary',
    },
  }, overrideReadOnly)
  .nameOverride(['rejectedDirectIndexTickerOptionsTitle', 'directIndexingPersonaTitle'], {
    _component: () => TitleTextLarge,
    _customProps: {
      color: 'textSecondary',
    },
  }, overrideReadOnly)
  .nameOverride(['rejectedDirectIndexTickerOptionsSubTitle', 'directIndexingPersonaSubTitle'], {
    _component: () => BodyTextMedium,
    _customProps: {
    },
  }, overrideReadOnly)
  .nameOverride('directIndexingPersona', {
    _component: () => BigPicklistInput,
  }, overrideReadOnly)
  .nameOverride(['rejectedDirectIndexTickersForPersonalReasons', 'rejectedDirectIndexTickersForComplianceReasons'], {
    _component: () => AutoCompleteInputLarge,
    _customProps: {
      multiple: true,
      fullWidth: true,
      helperText: '',
    },
  }, overrideReadOnly)
  .done();

const Template = ({ resource }) => {
  useBoneBackgroundColor();

  return (
    <MetaResourceRenderer
      layout={Layout}
      resource={resource}
      metaOverrideSet={metaOverrideSet}
    />
  );
};

Template.defaultProps = {};

Template.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default Template;
